import "../css/style.scss";
import "./components/navigation";
import "./components/copyright";
import "./components/bounce-swiper-prompt";
import "./pages/our-story-timeline";
import "./pages/recipe-archive-filter";
import "./modules/print";
import "./modules/accessibe-script";
 // import Swiper bundle with all modules installed
 import Swiper from 'swiper/bundle';
 // import styles bundle
 import 'swiper/css/bundle';
 import swiperParameters from '../src/modules/swiperParameters';
 
  var swiper = new Swiper(".swiper", {
    ...swiperParameters,
    // specific parameters
    breakpoints: {
        800: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
            allowTouchMove: false,
        },
    },
});

// initialize separate so the arrow controls just this one
var swiperTips = new Swiper(".swiperMarthasFavRecipes", {
    ...swiperParameters,
    navigation: {}, // Set navigation to an empty object
    // Remove navigation property
    breakpoints: {
        800: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
            allowTouchMove: false,
            navigation: {
                nextEl: ".custom-swiper-button-next", 
                prevEl: ".custom-swiper-button-prev", 
            },
        },
    },
    
});


var swiper = new Swiper('.swiper-container1', {
    ...swiperParameters,
    // navigation: {}, // Set navigation to an empty object
        breakpoints: {
              800: {
                slidesPerView: 4.5,
            spaceBetween: 5,
            centeredSlides: false,
            allowTouchMove: true,
            // navigation: {
            //     nextEl: ".swiper-button-next", 
            //     prevEl: ".swiper-button-prev", 
            // },
              },
             
        }
      });


      jQuery(document).ready(function ($) {
        // Function to set the background image of .product-detail-container::after
        function setBackgroundImage() {
          var imageUrl = ''; // Initialize with a default image URL or leave it empty
      
          // Check if the ACF field has a value for the current post
          if (typeof acf !== 'undefined') {
            var field = acf.getField('just_add_ingredient_image');
            if (field) {
              imageUrl = field.val(); // Get the ACF field value (image URL)
            }
          }
      
          // Set the background image dynamically
          $('.product-detail-container::after').css('background-image', 'url(' + imageUrl + ')');
        }
      
        // Call the function initially
        setBackgroundImage();
      
        // You might want to call the function again if the ACF field value changes
        // You can use ACF's change event to detect changes and update the background image accordingly
        if (typeof acf !== 'undefined') {
          acf.addAction('change_field', setBackgroundImage);
        }
      });
      